const Time1 = {
  orientation: "SQUARE",
  custom_size: { x: 50, y: 50 },
  nft_fit: "CONTAIN",
  nft_padding: 0,
  nft_surface: 0.03,
  backsideMatcap: "",
  backsideColor: "#ffffff",
  backsideTextureId: "",
  lights: 0,
  style_1: "SIMPLE_BOX",
  dimensions_1: { x: 2.9, y: 1.5000000000000002 },
  matCapId_1: "430404_BD9295_7E1E21_94544C",
  color_1: "#ffffff",
  textureId_1: "",
  surface_1: -0.11,
  profile_1: "CURVE_5",
  cartouche_1: "cartouche_01.fbx",
  cartoucheOffset_1: 0,
  cartoucheSides_1: 1,
  cartoucheFlip_1: false,
  cartoucheNudge_1: { x: 0, y: 0, z: 0 },
  echoLayout_1: "straight",
  echoMesh_1: "box",
  echoConfig_1: { x: 1, y: 1, z: 1 },
  repeat_1: 1,
  offset_1: 0,
  scale_1: { x: 1, y: 1, z: 1 },
  flowThickness_1: 0.4,
  flowRepeat_1: 1,
  flowRevolutions_1: 0,
  flowColor_1: "#ffffff",
  flowNoiseAmp_1: 0,
  flowOffset_1: 0,
  flowScale_1: 1,
  frameId_1: "frame_01.fbx",
  style_2: "ECHO",
  dimensions_2: { x: 0.8999999999999997, y: 0.6000000000000001 },
  matCapId_2: "D0CCCB_524D50_928891_727581",
  color_2: "#ffffff",
  textureId_2: "",
  surface_2: 2,
  profile_2: "BOX",
  cartouche_2: "cartouche_01.fbx",
  cartoucheOffset_2: 0,
  cartoucheSides_2: 1,
  cartoucheFlip_2: false,
  cartoucheNudge_2: { x: 0, y: 0, z: 0 },
  echoLayout_2: "straight",
  echoMesh_2: "sphere",
  echoConfig_2: { x: -11, y: 10.5, z: 3 },
  repeat_2: 1.18,
  offset_2: 0,
  scale_2: {
    x: 1.3800000000000006,
    y: 1.7200000000000006,
    z: 1.4600000000000006,
  },
  flowThickness_2: 0.4,
  flowRepeat_2: 1,
  flowRevolutions_2: 0,
  flowColor_2: "#ffffff",
  flowNoiseAmp_2: 0,
  flowOffset_2: 0,
  flowScale_2: 1,
  frameId_2: "frame_01.fbx",
  style_3: "SIMPLE_BOX",
  dimensions_3: { x: 0.8999999999999997, y: 0.5 },
  matCapId_3: "430404_BD9295_7E1E21_94544C",
  color_3: "#ffffff",
  textureId_3: "",
  surface_3: -0.11,
  profile_3: "CURVE",
  cartouche_3: "cartouche_01.fbx",
  cartoucheOffset_3: 0,
  cartoucheSides_3: 1,
  cartoucheFlip_3: false,
  cartoucheNudge_3: { x: 0, y: 0, z: 0 },
  echoLayout_3: "straight",
  echoMesh_3: "box",
  echoConfig_3: { x: 1, y: 1, z: 1 },
  repeat_3: 1,
  offset_3: 0,
  scale_3: { x: 1, y: 1, z: 1 },
  flowThickness_3: 0.4,
  flowRepeat_3: 1,
  flowRevolutions_3: 0,
  flowColor_3: "#ffffff",
  flowNoiseAmp_3: 0,
  flowOffset_3: 0,
  flowScale_3: 1,
  frameId_3: "frame_01.fbx",
  style_4: "SIMPLE_BOX",
  dimensions_4: { x: 0.5, y: 0.5 },
  matCapId_4: "D0CCCB_524D50_928891_727581",
  color_4: "#ffffff",
  textureId_4: "",
  surface_4: -0.01,
  profile_4: "CURVE",
  cartouche_4: "cartouche_04.fbx",
  cartoucheOffset_4: 10,
  cartoucheSides_4: 1,
  cartoucheFlip_4: false,
  cartoucheNudge_4: { x: 0, y: 0, z: 0 },
  echoLayout_4: "straight",
  echoMesh_4: "box",
  echoConfig_4: { x: 1, y: 1, z: 1 },
  repeat_4: 1,
  offset_4: 0,
  scale_4: { x: 1, y: 1, z: 1 },
  flowThickness_4: 0.4,
  flowRepeat_4: 1,
  flowRevolutions_4: 0,
  flowColor_4: "#ffffff",
  flowNoiseAmp_4: 0,
  flowOffset_4: 0,
  flowScale_4: 1,
  frameId_4: "frame_02.fbx",
  style_5: "",
  dimensions_5: { x: 0.5, y: 4.900000000000001 },
  matCapId_5: "3E2335_D36A1B_8E4A2E_2842A5",
  color_5: "#ffffff",
  textureId_5: "/img/diffuse/187.jpg",
  surface_5: 1.17,
  profile_5: "BOX",
  cartouche_5: "cartouche_03.fbx",
  cartoucheOffset_5: 5.6000000000000005,
  cartoucheSides_5: 5,
  cartoucheFlip_5: false,
  cartoucheNudge_5: { x: 0, y: 0, z: 0 },
  echoLayout_5: "straight",
  echoMesh_5: "box",
  echoConfig_5: { x: 1, y: 1, z: 1 },
  repeat_5: 1,
  offset_5: 0,
  scale_5: { x: 1, y: 1, z: 1 },
  flowThickness_5: 0.4,
  flowRepeat_5: 1,
  flowRevolutions_5: 0,
  flowColor_5: "#ffffff",
  flowNoiseAmp_5: 0,
  flowOffset_5: 0,
  flowScale_5: 1,
  frameId_5: "frame_01.fbx",
  style_6: "",
  dimensions_6: { x: 1, y: 1 },
  matCapId_6: "",
  color_6: "#ffffff",
  textureId_6: "",
  surface_6: 0.01,
  profile_6: "BOX",
  cartouche_6: "cartouche_01.fbx",
  cartoucheOffset_6: 0,
  cartoucheSides_6: 1,
  cartoucheFlip_6: false,
  cartoucheNudge_6: { x: 1, y: 1, z: 1 },
  echoLayout_6: "straight",
  echoMesh_6: "box",
  echoConfig_6: { x: 1, y: 1, z: 1 },
  repeat_6: 1,
  offset_6: 0,
  scale_6: { x: 1, y: 1, z: 1 },
  flowThickness_6: 0.4,
  flowRepeat_6: 1,
  flowRevolutions_6: 0,
  flowColor_6: "#ffffff",
  flowNoiseAmp_6: 0,
  flowOffset_6: 0,
  flowScale_6: 1,
  frameId_6: "frame_01.fbx",
  grid: false,
  shadow: false,
  background: false,
  backgroundColor: "#ffffff",
  orbitStyle: "ORBIT_FRONT",
  orbitSpeed: "SLOW",
  backLogo: "/img/frahm_sample.svg",
  campaignLogo: "",
};
export default Time1;
